export default __webpack_public_path__ + "static/media/B0002.05eeefb8.png";